<i [class]="iconClass()">
  @if (hasCount) {
    <div
      class="translate-middle badge rounded-pill bg-primary notification-pill">
      {{ getCount() }}
    </div>
  }
</i>
